import { SliceCaseReducers } from '@reduxjs/toolkit/src/createSlice';

import { DataProcessingMergeProps } from '../../../types/reduxTypes/dataProcessingMerge';

const createReducer = <T extends SliceCaseReducers<DataProcessingMergeProps>>(reducer: T) => ({ ...reducer });

const reducers = createReducer({
  setDataProcessingMergeData(state, action) {
    state.dataProcessingMergeData = action.payload;
  },
  setDataProcessingMergeStatus(state, action) {
    state.dataProcessingMergeStatus = action.payload;
  }
});

export default reducers;
